import type { BeforeInstallPromptEvent } from './types'
import { useEventListener } from '@vueuse/core'
import { ref } from 'vue'

const isInstalled = ref(false)
let installEvent: BeforeInstallPromptEvent

export const usePwa = () => {
    useEventListener(window, 'appinstalled', () => {
        isInstalled.value = true
    })

    useEventListener(window, 'beforeinstallprompt', (e: BeforeInstallPromptEvent) => {
        e.preventDefault()
        isInstalled.value = false
        installEvent = e
    })

    const showInstallPrompt = async () => {
        if (!installEvent) return
        await installEvent.prompt()
    }

    return {
        isInstalled,
        showInstallPrompt,
    }
}
